export class ImageUtils {
    static resizeImage(base64, requiredSize) {
        const image = new Image();
        const canvas = document.createElement("canvas");
        return new Promise((resolve, reject) => {
            const currentSize = this.getBinarySize(base64);
            if (currentSize <= requiredSize) {
                resolve(base64);
                return;
            }
            const factor = Math.sqrt(currentSize / requiredSize);
            image.onload = () => {
                const width = image.width / factor;
                const height = image.height / factor;
                canvas.width = width;
                canvas.height = height;
                const context = canvas.getContext("2d");
                context.clearRect(0, 0, width, height);
                context.drawImage(image, 0, 0, width, height);
                const dataUrl = canvas.toDataURL();
                const resizedBase64 = this.dataURLtoBase64(dataUrl);
                if (this.getBinarySize(resizedBase64) > requiredSize) {
                    this.resizeImage(resizedBase64, requiredSize)
                        .then((furtherResizedBase64) => {
                        resolve(furtherResizedBase64);
                    });
                }
                else {
                    resolve(resizedBase64);
                }
            };
            image.src = this.base64TotoDataURL(base64);
        });
    }
    static dataURLtoBase64(dataUrl) {
        return dataUrl.substr(dataUrl.indexOf(",") + 1);
    }
    static base64TotoDataURL(base64) {
        return "data:image;base64," + base64;
    }
    static getBinarySize(base64) {
        return base64.length / 4 * 3;
    }
    static base64ToSvg(base64) {
        if (base64 == undefined || base64.length == 0) {
            return undefined;
        }
        const bytes = atob(base64);
        if (bytes.match(/^<svg\b/)) {
            return bytes;
        }
        if (bytes.match(/^<\?xml\b/)) {
            const i = bytes.search(/<svg\b/);
            return i == -1 ? undefined : bytes.slice(i);
        }
        return undefined;
    }
}
//# sourceMappingURL=image-utils.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fedelta-pos/data-client/utils/image-utils.js
// module id = null
// module chunks = 